import React from 'react';
import { constructUrl } from '../../../utils/UrlConstructor';
import { formatPriceString } from '../modals/product/extended-product-modal/util/ProductModalHelpers';
import ReactHtmlParser from "react-html-parser";
import './CartItem.css'


const formatProductPrice = (price, currency) => {
    return formatPriceString(price, currency);
}


const CartItem = ({ name, price, thumbnail, menuTextFontStyle, prefix, removeFromCart, color, sku,removeText,fontFamilyByStore }) => {   
    return (
        <React.Fragment>
            <div className='cart-item-container'>
                {thumbnail && <img className='cart-item-thumbnail' src={constructUrl(thumbnail)} />}
                {!thumbnail && <div className='cart-item-thumbnail'>&nbsp;</div>}
                <div className='cart-item-info' style={menuTextFontStyle}>
                    <span style={{ fontWeight: 'bold' }}>{ReactHtmlParser(name)}</span>
                    <span>{color}</span>
                    {/* <span>{`${prefix} ${price} `}</span> */}
                    <span>{formatPriceString(price, prefix)}</span>
                </div>
            </div>
            <div className='cart-item-remove' style={{...fontFamilyByStore}} onClick={() => removeFromCart(sku)}>{removeText}</div>
            <hr className="cart-item-break" />
        </React.Fragment>
    )
}

export default CartItem;
